export default __webpack_public_path__ + "static/media/title based targeting 5.d88c3917.svg";